var Handlebars = require("/Users/Shanfan/enhancer/widget-configurator/enhancer-custom-window/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div id=\"datasource-list-wrapper\" class=\"ui-state-default\">\n    <div id=\"datasource-list-header\" class=\"ui-widget-header\">\n        "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.datasourceList : stack1), depth0))
    + "\n    </div>\n    <ul id=\"datasource-list\"></ul>\n    <input id=\"datasource-name\" placeholder=\"Datasource Name\" type=\"text\">\n    <button id=\"add-datasource\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.addDatasource : stack1), depth0))
    + "</button>\n</div>\n<div id=\"datasource-editor-wrapper\">\n    <div id=\"datasource-editor-header\" class=\"ui-widget-header\">\n        "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.datasourceEditor : stack1), depth0))
    + "\n    </div>\n    <div id=\"datasource-editor\"></div>\n    <div id=\"datasource-action-bar\">\n        <button id=\"datasource-save\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.save : stack1), depth0))
    + "</button>\n        <button id=\"datasource-test\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.testSql : stack1), depth0))
    + "</button>\n        <button id=\"datasource-delete\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1["delete"] : stack1), depth0))
    + "</button>\n    </div>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./src/managers/datasource/index.html
 ** module id = 41
 ** module chunks = 0
 **/